<template>
   <div class="crud-wrapper">

      <crud-toolbar :modalMode="modalMode" :newState="newState" :showBack="false" :title="modalTitle"
                    @onCommand="toolbarCommand"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" fullWidth v-model="validForm">

         <v-layout row wrap>
            <a-text-field 
               :append-icon="showCurrent ? 'visibility' : 'visibility_off'"
               :type="showCurrent ? 'text' : 'password'"
               @click:append="showCurrent = !showCurrent"
               label="Senha Atual" 
               v-model="formData.currentPin" 
               validate="required" xs12
            ></a-text-field>

            <a-text-field
               :append-icon="showNew ? 'visibility' : 'visibility_off'"
               :type="showNew ? 'text' : 'password'"
               @click:append="showNew = !showNew" 
               label="Nova Senha" 
               v-model="formData.loginPin" 
               validate="required" xs12
            ></a-text-field>
         </v-layout>
      </crud-form>

   </div>
</template>

<script>

   import auth from '@consigmais-team/vue-common/services/auth.services';
   import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

   export default CrudFormClass.extend({
      name: 'ChangePin',

      data () {
         return {
            formName: 'pinForm',
            showCurrent: false,
            showNew: false,
            formData: {
               currentPin: null,
               loginPin: null
            }
         };
      },

      methods: {
         save () {
            this.validateForm()
               .then(() => {
                  auth.changePassword(this.formData).then(data => {
                     this.$store.dispatch('company/stSetPinChanged');

                     this.$notifyUser({
                        type: 'success',
                        message: 'Senha alterada com sucesso!'
                     });

                     if (this.modalMode) {
                        this.$emit('onDataSaved', data);
                     }

                  });

               })
               .catch(() => {
                  this.$notifyUser({
                     type: 'error',
                     message: this.$t('appMsg.invalidForm')
                  });
               });

         }

      },

      mounted() {
         console.log('ChangePin Created!', this.modalMode);
      }

   });
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/change-pin.vue